import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { APP_BASE_URL } from 'common/constants';

import { useRenewalStyles } from '../styles';

const Renewal = ({ pinLink, pin }) => {
  const classes = useRenewalStyles();
  const { qrImage, renewUrl } = pinLink;

  return (
    <div className={classes.root}>
      {!!qrImage && (
        <Link to={renewUrl} data-id="BWane">
          <img src={qrImage} alt="Renewal QR" />
        </Link>
      )}
      {!!pin && <h5>Pin: <strong>{pin}</strong></h5>}
      {!!renewUrl && (
        <h5>Renewal: <Link to={renewUrl} data-id="TzALy">{APP_BASE_URL}{renewUrl}</Link></h5>
      )}
    </div>
  );
};

Renewal.propTypes = {
  pin: PropTypes.string.isRequired,
  pinLink: PropTypes.object.isRequired,
};

export default Renewal;
